import _extends from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["group", "groupLevel"];
import React from "react";
var __jsx = React.createElement;
import { Tab } from '@material-ui/core';
import { useIntl } from 'react-intl';
import FormBuilder from 'components/content/FormBuilder';
import { getGroupIcon } from 'libs/content/utils';
import { Container, TitleContainer, TitleIconContainer, TitleText } from './GroupField.style';

var GroupField = function GroupField(_ref) {
  var group = _ref.group,
      groupLevel = _ref.groupLevel,
      other = _objectWithoutProperties(_ref, _excluded);

  var intl = useIntl();
  var Icon = getGroupIcon(group.name);
  return __jsx(React.Fragment, null, groupLevel === 0 ? __jsx(Tab, _extends({
    label: intl.formatMessage({
      id: group.labelId
    }),
    id: "simple-tabpanel-".concat(group.name),
    disableRipple: true
  }, other)) : __jsx(Container, null, __jsx(TitleContainer, null, __jsx(TitleIconContainer, null, __jsx(Icon, null)), __jsx(TitleText, null, intl.formatMessage({
    id: group.labelId
  }))), __jsx(FormBuilder, {
    formFields: group.fields,
    groupLevel: groupLevel
  })));
};

export default GroupField;